import { render, staticRenderFns } from "./LoginCard.vue?vue&type=template&id=20b505f9&scoped=true&"
import script from "./LoginCard.vue?vue&type=script&lang=js&"
export * from "./LoginCard.vue?vue&type=script&lang=js&"
import style0 from "./LoginCard.vue?vue&type=style&index=0&id=20b505f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b505f9",
  null
  
)

export default component.exports